import { render, staticRenderFns } from "./todayTotalOperationData.vue?vue&type=template&id=59613b4c&scoped=true"
import script from "./todayTotalOperationData.vue?vue&type=script&lang=js"
export * from "./todayTotalOperationData.vue?vue&type=script&lang=js"
import style0 from "./todayTotalOperationData.vue?vue&type=style&index=0&id=59613b4c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59613b4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59613b4c')) {
      api.createRecord('59613b4c', component.options)
    } else {
      api.reload('59613b4c', component.options)
    }
    module.hot.accept("./todayTotalOperationData.vue?vue&type=template&id=59613b4c&scoped=true", function () {
      api.rerender('59613b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/waybillKanbanBoard/component/todayTotalOperationData.vue"
export default component.exports